import React from "react";
import Slide from "react-reveal";
import { useTranslation } from 'react-i18next';

const Resume = () => {
  const { t } = useTranslation();

  return (
    <section id="resume">
      <Slide left duration={1300}>
        <div className="row education">
          <div className="three columns header-col">
            <h1>
              <span>{t("resume.how_to_play_title")}</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <div>
                  <h3>{t("resume.create_room.title")}</h3>
                  <p className="info">
                    <em className="date">
                      {t("resume.create_room.description")}
                    </em>
                  </p>
                  <p>{t("resume.create_room.start_game")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Slide>

      <Slide left duration={1300}>
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>{t("resume.mechanics_title")}</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <div>
              <h3>{t("resume.daily_challenges.title")}</h3>
              <p className="info">
                <em className="date">
                  {t("resume.daily_challenges.description_1")}
                </em>
              </p>
              <p>{t("resume.daily_challenges.description_2")}</p>
              <p>{t("resume.daily_challenges.description_3")}</p>
            </div>
          </div>
        </div>
      </Slide>

      <Slide left duration={1300}>
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>{t("resume.challenges_title")}</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <div>
              <h3>{t("resume.challenge_description.title")}</h3>
              <p className="info">
                <em className="date">
                  {t("resume.challenge_description.voting_challenges")}
                </em>
              </p>
              <p>{t("resume.challenge_description.voting_description")}</p>
              <p>{t("resume.challenge_description.scoring")}</p>
            </div>
          </div>
        </div>
      </Slide>

      <Slide left duration={1300}>
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>{t("resume.competition_title")}</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <div>
              <h3>{t("resume.play_and_win.title")}</h3>
              <p className="info">
                <em className="date">
                  {t("resume.play_and_win.description")}
                </em>
              </p>
            </div>
            <div>
              <h3>{t("resume.seasons.title")}</h3>
              <p className="info">
                <em className="date">
                  {t("resume.seasons.description_1")}
                </em>
              </p>
              <p>{t("resume.seasons.description_2")}</p>
              <p>{t("resume.seasons.winners")}</p>
            </div>
          </div>
        </div>
      </Slide>

      <Slide left duration={1300} >
        <div className="row work" id="delete-account" >
          <div className="three columns header-col">
            <h1>
              <span>{t("resume.your_account_title")}</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <div>
              <h3>{t("resume.profile_section.title")}</h3>
              <p className="info">
                <em className="date">
                  {t("resume.profile_section.description")}
                </em>
              </p>
            </div>
            <div>
              <h3>{t("resume.delete_account_section.title")}</h3>
              <p className="info">
                <em className="date">
                  {t("resume.delete_account_section.description_1")}
                </em>
              </p>
              <p>{t("resume.delete_account_section.description_2")}</p>
            </div>
          </div>
        </div>
      </Slide>
    </section>
  );
}

export default Resume;
